const formLogin = document.querySelector('.form-login');

if (formLogin) {
    const viewButtons = formLogin.querySelectorAll('.form-login__view-button');
    const viewWrappers = formLogin.querySelectorAll(
        '.form-login__view-wrapper'
    );

    const handleButtonClick = button => {
        const targetView = button.getAttribute('data-change-to');
        viewWrappers.forEach(view => {
            if (view.classList.contains(targetView)) {
                setTimeout(() => {
                    view.classList.remove('d-none');
                    view.classList.remove('-hide');
                }, 300);
            } else {
                view.classList.add('-hide');
                setTimeout(() => {
                    view.classList.add('d-none');
                }, 300);
            }
        });
    };

    if (viewButtons.length > 0 && viewWrappers.length > 0) {
        viewButtons.forEach(button => {
            button.addEventListener('click', () => handleButtonClick(button));
        });
    }
}
